module.exports = __webpack_public_path__ + "img/red-marker-icon.37877828.png";